// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"AdminGameLayout_parentContainer__13y_N"};